import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledPromptTipsModal = styled.div`
  background-color: ${COLORS.darkBlue};;
  color: ${COLORS.white};
  padding: 20px;
  border-radius: 8px;
  text-align: left;
`;

export {
  StyledPromptTipsModal
}
